import {addDays, format} from 'date-fns'

export const searchRequest = () => ({
        applicantCountryId: null,
        convertToCurrency: null,
        countryId: null,
        startDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        endDate: format(addDays(new Date(), 10), 'yyyy-MM-dd'),
        adults: 1,
        childrenAges: [],
    }),
    searchResponse = () => ({
        products: [],
        currency: null,
        filters: filters(),
    }),
    filters = () => ({
        price: [Infinity, 0],
        supplierName: [],
        visaNames: [],
    }),
    bookingFields = () => ({
        BIRTHDATE: {
            mainTouristStatus: 'MANDATORY',
            allTouristsStatus: 'MANDATORY',
            childrenStatus: 'MANDATORY',
        },
        CITIZENSHIP: {
            mainTouristStatus: 'MANDATORY',
            allTouristsStatus: 'MANDATORY',
            childrenStatus: 'MANDATORY',
        },
        EMAIL: {
            mainTouristStatus: 'DISABLED',
            allTouristsStatus: 'DISABLED',
            childrenStatus: 'DISABLED',
        },
        PASSPORT_NUMBER: {
            mainTouristStatus: 'DISABLED',
            allTouristsStatus: 'DISABLED',
            childrenStatus: 'DISABLED',
        },
        PHONE: {
            mainTouristStatus: 'DISABLED',
            allTouristsStatus: 'DISABLED',
            childrenStatus: 'DISABLED',
        },
        PREFIX: {
            mainTouristStatus: 'OPTIONAL',
            allTouristsStatus: 'OPTIONAL',
            childrenStatus: 'OPTIONAL',
        },
    })
